import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: CartState = {
    items: [],
    status: 'idle',
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addItem(state, action: PayloadAction<CartItem>) {
            const existing = state.items.find(
                (item) => item.id === action.payload.id && item.type === action.payload.type
            );
            if (existing) {
                existing.quantity += action.payload.quantity;
            } else {
                state.items.push(action.payload);
            }
        },
        removeItem(state, action: PayloadAction<CartItem>) {
            state.items = state.items.filter(
                (item) => !(item.id === action.payload.id && item.type === action.payload.type)
            );
        },
        updateQuantity(state, action: PayloadAction<CartItem>) {
            const item = state.items.find(
                (i) => i.id === action.payload.id && i.type === action.payload.type
            );
            if (item) {
                item.quantity = action.payload.quantity;
            }
        },
        clearCart(state) {
            state.items = [];
        },
        setCart(state, action: PayloadAction<CartItem[]>) {
            state.items = action.payload;
        },
    },
});

export const { addItem, removeItem, updateQuantity, clearCart, setCart } = cartSlice.actions;
export default cartSlice.reducer;
